import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import usePostInsertReschedule from 'Domain/reschedule/usePostInsertReschedule';
import ButtonOutline from 'UiKit/button/buttonOutline';
import ButtonSolid from 'UiKit/button/buttonSolid';
import { TextSemiBold } from 'UiKit/typography';

import checkDisabledButton from 'View/reschedule-form/helper/checkDisabledButton';
import useOnCancelModal from 'View/reschedule-form/hooks/useOnCancelModal';
import useOnSubmitModal from 'View/reschedule-form/hooks/useOnSubmitModal';

import styles from './styles.module.css';

const ActionButton = ({ form }) => {
  const { t } = useTranslation();
  const { watch } = form;

  const formField = watch();

  const onOpenCancelModal = useOnCancelModal();
  const onOpenSubmitModal = useOnSubmitModal(formField);

  const disabledButton = checkDisabledButton(formField);

  const { mutate: onPostReschedule } = usePostInsertReschedule();

  return (
    <Box className={styles['action-button__container']}>
      <ButtonOutline width={'100%'} className={styles['action-button__cancel']} onClick={onOpenCancelModal}>
        <TextSemiBold className={styles['action-button__text']}>{t('common:cancel')}</TextSemiBold>
      </ButtonOutline>

      <ButtonSolid
        width={'100%'}
        className={styles['action-button__send']}
        type="button"
        onClick={() => onOpenSubmitModal(onPostReschedule)}
        disabled={disabledButton}
      >
        <TextSemiBold className={styles['action-button__text']}>{t('common:submit')}</TextSemiBold>
      </ButtonSolid>
    </Box>
  );
};

export default ActionButton;
